import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Button, Grid, Select, TextField, Tooltip, Typography } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useFormik } from "formik";
import * as yup from "yup";
import style from './Lab.module.scss'
import { CMLabel } from '../Form/FormLabels';
import { FlexDiv } from '../Flex/Flex';
import LabModel from './LabModel';
import { CMButton, CMLinkButton } from '../Button/Button';
import { useEffect } from 'react';
import { Dropdown } from 'reactstrap';
import { buttonStyle } from '../Helpers/InlineStyles';
import { CMAutoComplete } from '../AutoComplete/AutoComplete';
import { useNavigate, useParams } from 'react-router';
import { PageRoutes } from '../../../constants';
import { toast } from 'react-toastify';
import { addLab, editLab, getByLabId, labDropdown } from '../../../Pages/Lab/LabServices';
import MedicineModel from './MedicineModel';
import { addMedicine, editMedicine,MedicineDropdown ,getByMedicineId, MedicineAllFields,listPatientMedicine} from '../../../Pages/Medicines/MedicinesServices';
 
interface Column {
    id: 'medicine_name' | 'opening_stock' | 'medicine_issued' |'date';
    label: string;
    minWidth?: number;
    align?: 'left';
    format?: (value: number) => string;
}
 
const columns: readonly Column[] = [
    {
        id: 'medicine_name',
        label: 'Medicine Name',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'opening_stock',
        label: 'opening stock',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'medicine_issued',
        label: 'medicine Issued',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'date',
        label: 'Date',
        minWidth: 170,
        align: 'left',
    }
];
interface Data {
    medicine_name: string;
    opening_stock: string;
    medicine_issued: string;
    date: string;
}
 
 
const MedicineTable = (props: any) => {
 
    const [openModal, setOpenModal] = React.useState(false);
    const [tableData, setTableData] = React.useState<any>([]);
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const [SelectedRowData, setSelectedRowData] = React.useState<any>();
    const [index, setIndex] = React.useState<any>(null);
    const [patientName, setPatientName] = React.useState<any>([]);
    const [medicinedropdown, setMedicedropdown] = React.useState<any>([]);
    const history = useNavigate();
    const { id } = useParams();
 
    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem('lab') || '[]');
        setTableData(storedData);
        labDropdown().then((res: any) => {
            setPatientName(res)
        })
        MedicineDropdown().then((res: any) => {
            setMedicedropdown(res);
        })
        if (id) {
            getByMedicineId(id + "").then((res: any) => {
                setSelectedRowData(res)
                formik.setValues(res);
                // if (Array.isArray(res) && res.length > 0) {
                    // formik.setValues(res[0]);
                    MedicineDropdown().then((dropRes: any) => {
                        setMedicedropdown(dropRes)
 
                    // console.log(medicinedropdown,"medicinedropdown",dropRes,res?.medicine_details[1].medicine_name);
                    let val:any = res?.medicine_details;
                    for (let i = 0; val?.length > i; i++) {
                        const labTestId = val[i]?.medicine_name;
                        if (labTestId) {
                            // const labTest = dropRes?.find((e: any) => e.label == labTestId)?.label;
 
                            val[i].medicine_name = labTestId;
                        console.log(res,"zdsdres",labTestId);
                        } else {
                            console.warn("Medicine name not found or is empty.");
                        }
                    }
                    setTableData(val);
                })
                // }
                labDropdown().then((response: any) => {
                    setPatientName(response)
                    let val = response?.find((e:any)=>e.label ===  res?.patient_id).label;
                    formik.setFieldValue('patient_id', val);
                })
            });
        }
        else{
            listPatientMedicine().then((response: any) => {
                let roomsList = response.data.map((item: any) => item.patient_id)
                console.log(roomsList, 'roomsList')
                labDropdown().then((res: any) => {
                    console.log(res, 'res')
                    setPatientName(res);
                    let unmatchedData = res.filter((e: any) => {
                        return !roomsList.some((room: any) => room === e.label);
                    });
                    console.log(unmatchedData, 'unmatchedData');
                    setPatientName(unmatchedData);

                })
            })
            labDropdown().then((labAddResponse: any) => {
                setPatientName(labAddResponse);
            })
        }
    }, []);
 
    const handleShow = () => {
        setOpenModal(true);
    };
    const Edithandle = (rowData: any, index: any) => {
        console.log(rowData, 'rowwwwwwwwwwwwwwwwwwwwwwwww')
        setOpenEditModal(true);
        setSelectedRowData(rowData);
        setIndex(index)
    };
 
    const handledit = (selectedRowData: any) => {
        if (typeof selectedRowData?.medicine_name == 'number') selectedRowData.medicine_name = patientName?.find((e: any) => e.id == selectedRowData.medicine_name).label
        tableData[index] = selectedRowData;
    }
    const handleDelete = (index: any) => {
        const updatedRecords = tableData.filter((v: any, i: any) => index !== i);
        setTableData(updatedRecords);
    };
 
    const handleClose = () => setOpenModal(false);
    const handleAddRow = (newRow: Data) => {
        const updatedData = ([...tableData, newRow]);
        setTableData(updatedData);
        formik.setFieldValue('medicine_details', updatedData)
        localStorage.setItem('medicine', JSON.stringify(updatedData));
    }
    const handleChange = (fields: any, e: any) => {
        formik.setFieldValue(fields, e.target.value)
        formik.setFieldValue("medicine_details")
    }
    const handleDropdownChange = (fields: any, e: any) => {
        formik.setFieldValue(fields, e.label)
    }
    const formik: any = useFormik({
        initialValues: {
            patient_id: SelectedRowData?.patient_id ? SelectedRowData?.patient_id : '',
            medicine_details:''
        },
        validationSchema: yup.object({
            patient_id: yup.string().required('Patient ID  is required!'),
        }),
        onSubmit: (values: any) => {
            // let totalvalues: any = { ...values }
            console.log(values,'onsubmit')
            // totalvalues.contact_number = totalvalues.contact_number.id.toS    tring()  
            if (id) {
                editMedicine(values, id).then((res: any) => {
                    formik.setValues(res)
                    toast.success("Record Updated Successfully")
                    history(PageRoutes.MEDICINE_LIST);
                }, (error: any) => {
                    console.log(error)
                });
            } else {
                addMedicine(values).then((res: any) => {
                    // values?.medicine_details.forEach((item:any) => {
                    //     item.medicine_name = item.medicine_name.id;
                    // });
                    toast.success("Record Created Successfully")
                    history(PageRoutes.MEDICINE_LIST);
                }, (error: any) => {
                    console.log(error)
                });
            }
        }
    });
    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={3} xs={12} sm={12} md={12} lg={12}>
                {props?.EDIT == "EDIT_MEDICiNE" ? 
                <Grid item xs={12} sm={12} md={12} lg={12}>
                        <CMLabel>Patient Id</CMLabel>
                        <CMAutoComplete options={patientName} disabled={true} placeholder="Enter Patient Unique Id" name="tests"
                                     value={ formik?.values?.patient_id}
                                     onChange={(e: any) => handleDropdownChange("patient_id", e)} errors={formik.touched.patient_id && Boolean(formik.errors.patient_id)}
                            helperText={formik.touched.patient_id && formik.errors.patient_id} />

                    </Grid>:
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <CMLabel>Patient Id</CMLabel>
                                    <CMAutoComplete options={patientName} disabled={false} placeholder="Enter Patient Unique Id" name="tests"
                                                 value={formik?.values?.patient_id || ""}
                                                 onChange={(e: any) => handleDropdownChange("patient_id", e)} errors={formik.touched.patient_id && Boolean(formik.errors.patient_id)}
                                        helperText={formik.touched.patient_id && formik.errors.patient_id} />
            
                                </Grid>}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "flex-end", mt: 1, mb: 2 }} >
                            <Button variant='contained' value="ADD" color='primary' onClick={handleShow}> ADD</Button>
                        </Grid>
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: 440 }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                    className={style.labtablebg}
                                                >
                                                    <Typography><b>{column.label}</b></Typography>
                                                </TableCell>
                                            ))}
                                            <TableCell
                                                key={'action'}
                                                className={style.labtablebg}>
                                                <Typography><b>Action</b></Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tableData?.map((row: any, i: any) => {
                                                return (
                                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.result}>
                                                        {columns.map((column) => {
                                                            const value: any = row[column.id];
                                                            return (
                                                                <TableCell key={column.id} align={column.align}>
                                                                    {column.format && typeof value === 'number'
                                                                        ? column.format(value)
                                                                        : typeof value === 'object' ? value.label : value}
                                                                </TableCell>
                                                            );
                                                        })}
                                                          <TableCell key={"action"} >
                                                        <FlexDiv>
                                                            <Typography sx={{ marginLeft: "10px" }}>
                                                                <Tooltip title="Edit">
                                                                    <Button className={style.buttonadj} variant="outlined" value="edit" color='primary' size="small" onClick={() => Edithandle(row, id)} >Edit</Button>
                                                                </Tooltip>
                                                                {/* <Tooltip title="Delete" sx={{ marginLeft: "5px"}}>
                                                                    <Button className={style.buttonadj} variant="outlined" value="delete" color='error' size="small" onClick={() => handleDelete(i)}>Delete</Button>
                                                                </Tooltip> */}
                                                            </Typography>
                                                        </FlexDiv>
                                                    </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        {
                                            !tableData?.length ?
                                                <TableCell align='center' colSpan={columns.length + 1}>
                                                    No Records Found
                                                </TableCell> : null
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "end", marginTop: '10px' }}>
                            <Box component='div'
                                sx={buttonStyle}
                            >
                                <Box component='span' mr={2}>
                                    <CMLinkButton variant="contained" color="secondary" value="Cancel" link={PageRoutes.MEDICINE_LIST} />
                                </Box>
                                <Box component='span'>
                                    <CMButton variant="contained" value="Submit" color="primary" type="submit"></CMButton>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
            {openModal && <MedicineModel show={openModal} onHide={handleClose} header="Add Medicine Details" onAddRow={handleAddRow} />}
            {openEditModal && <MedicineModel show={openEditModal} onHide={() => setOpenEditModal(false)} edit={handledit} rowData={SelectedRowData} header="Update Medicine Details" />}
        </>
    );
}
 
export default MedicineTable;